import React from 'react';

import { Box, Typography, Stack } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

// import { isMobileDevice } from 'global-services/OhsMobileServices';

const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=au.com.safetychampion.scmobile';
const APP_STORE_URL = 'https://apps.apple.com/au/app/safety-champion-software/id1476478938';

const useStyles = makeStyles()({
  root: {
    minHeight: '100vh',
    background: '#0a253b',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'inherit',
    paddingLeft: 8,
    paddingRight: 8,
  },
  logoBox: {
    marginBottom: 24,
  },
  logo: {
    width: 120,
    marginBottom: 16,
  },
  title: {
    fontWeight: 'bold',
    marginBottom: 16,
    textAlign: 'center',
    color: '#fff',
    fontSize: '28px',
  },
  text: {
    textAlign: 'center',
    maxWidth: 340,
    marginBottom: 16,
    fontSize: '20px',
    lineHeight: '26px',
  },
  textLast: {
    textAlign: 'center',
    maxWidth: 340,
    marginBottom: 24,
    fontSize: '18px',
    lineHeight: '24px',
  },
  stack: {
    marginBottom: 24,
  },
  button: {
    textTransform: 'none',
    background: '#fff',
    color: '#0a253b',
    fontWeight: 700,
    fontSize: '1.1rem',
    borderRadius: 8,
    minWidth: 220,
    paddingTop: 10,
    paddingBottom: 10,
    boxShadow: 'none',
    '&:hover': {
      background: '#e0e0e0',
    },
  },
});

function OhsAppInstallPrompt() {
  const { classes } = useStyles();
  // const { pathname } = window.location;
  // const isMobile = isMobileDevice();
  return (
    <Box className={classes.root}>
      <Box className={classes.logoBox}>
        <img
          src="/img/Safety%20Champion%20Logo_white.png"
          alt="Safety Champion"
          className={classes.logo}
        />
      </Box>
      <Typography variant="h4" className={classes.title}>
        Almost there!
      </Typography>
      <Typography className={classes.text}>
        Download the <b>Safety Champion</b> app and rescan the QR code to get started.
      </Typography>
      <Typography className={classes.textLast}>
        If you&apos;re a visitor, you can also sign in through Visitor Only option in the app.
      </Typography>
      <Stack direction="row" spacing={2} className={classes.stack}>
        <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="/img/get-it-on-google-play-badge-logo.png"
            alt="Get it on Google Play"
            style={{ height: 50 }}
          />
        </a>
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="/img/download-on-the-apple-store-logo.svg"
            alt="Download on the App Store"
            style={{ height: 50 }}
          />
        </a>
      </Stack>
      {/* {isMobile === true && pathname && (
        <Button
          href={`com.safetychampion.app://redirect${pathname}`}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          className={classes.button}
        >
          Open the App
        </Button>
      )} */}
    </Box>
  );
}
OhsAppInstallPrompt.defaultProps = {
  appPath: 'login',
};
export default OhsAppInstallPrompt;
